/** 无需登录即可访问的路由（与 router 守卫、用户协议弹窗共用） */
const PUBLIC_EXACT = new Set(["/", "/more", "/login"]);

/** 公告列表与详情：公开浏览，不要求登录、不弹用户协议 */
export function isPublicRoutePath(path) {
    if (!path || typeof path !== "string")
        return false;
    if (PUBLIC_EXACT.has(path))
        return true;
    if (path === "/announcements" || path.startsWith("/announcements/"))
        return true;
    return false;
}

/** 首启用户协议：公告页为公开内容，不展示协议遮罩 */
export function shouldSkipUserAgreement(path) {
    return isPublicRoutePath(path);
}
